import { Toast } from 'vant'

Toast.setDefaultOptions('loading', { forbidClick: true, duration: 0 })
const LOADING_TIMEOUT = 0

let loading
let timeout
export default {
  show(options = {}) {
    timeout = setTimeout(() => {
      loading = Toast.loading(Object.assign({
        message: '加载中...'
      }, options))
    }, LOADING_TIMEOUT)
    return loading
  },

  hide() {
    if (loading) {
      loading.clear()
    }
    clearTimeout(timeout)
    return loading
  }
}
